import { AnyAction } from 'redux';

import * as constants from 'redux/constants/persons.constants';
import { ITableUpdate } from 'types/table.types';
import { IPersonsFormData } from 'views/PersonsView/components/PersonsForm/types';

export const onDelete = (id: string): AnyAction => ({
  type: constants.PERSONS_ON_DELETE_REQUESTED,
  id,
});

export const onGetAll = (data: ITableUpdate): AnyAction => ({
  type: constants.PERSONS_ON_GET_ALL_REQUESTED,
  ...data,
});

export const onGetForm = (): AnyAction => ({
  type: constants.PERSONS_ON_GET_FORM_REQUESTED,
});

export const onGetOne = (id: string): AnyAction => ({
  type: constants.PERSONS_ON_GET_ONE_REQUESTED,
  id,
});

export const onSave = (formData: IPersonsFormData, id?: string): AnyAction => ({
  type: constants.PERSONS_ON_SAVE_REQUESTED,
  formData,
  id,
});
